module.exports = __webpack_public_path__ + "front/img/kv04.b18dfec6.png";